import * as React from 'react'
import { useEffect } from 'react'

import { Breadcrumb, useBreadcrumbs } from '@/hooks/use-breadcrumbs.tsx'

export interface BreadcrumbsProps {
  items?: Array<Breadcrumb>
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const { setBreadcrumbs } = useBreadcrumbs()

  useEffect(() => {
    if (items) {
      setBreadcrumbs(items)
    }

    return () => {
      setBreadcrumbs([])
    }
  }, [items])

  return null
}
